import { render, staticRenderFns } from "./README.md?vue&type=template&id=461601ee&"
import script from "./README.md?vue&type=script&lang=js&"
export * from "./README.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "README.md"
export default component.exports